import React, { FunctionComponent } from 'react'
import { LoginHelpLink } from '../../LoginHelpLink'
import styles from '../styles.module.css'
export const NeedHelpLink: FunctionComponent = () => (
  <div className={styles.inlineLink}>
    <LoginHelpLink pageName='Login Password Page' />
  </div>
)
